var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIconMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 8.8999V16.8999C17.875 17.6956 17.5853 18.4586 17.0695 19.0212C16.5538 19.5838 15.8543 19.8999 15.125 19.8999H6.875C6.14565 19.8999 5.44618 19.5838 4.93046 19.0212C4.41473 18.4586 4.125 17.6956 4.125 16.8999V8.8999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 9.90006L17.875 8.90006L12.375 4.90006L11.5042 4.27006C11.3545 4.16253 11.1792 4.10522 11 4.10522C10.8208 4.10522 10.6455 4.16253 10.4958 4.27006L9.625 4.90006L4.125 8.90006L2.75 9.90006",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIconMenu);
export default __webpack_public_path__ + "static/media/dashboardIconMenu.16ae16cc99ce76638997e312790191bf.svg";
export { ForwardRef as ReactComponent };